import React, { useEffect, useState } from "react";
import "./likesec.scss";
import { db } from "../../config/firebase";
import { getDocs, collection, updateDoc, doc } from "firebase/firestore";
import { aboutSec } from "../../data/MainData";
import imageAbout from "../../assest/Thumbs-up.gif";

export default function LikeSec() {
  const [likeCount, setLikeCount] = useState();
  const [likeCountTwo, setLikeCountTwo] = useState();
  const [newLike, setNewLike] = useState();
  const [likeId, setLikeId] = useState();

  const likeCountCollectionRef = collection(db, "likes");

  useEffect(() => {
    const getLikes = async () => {
      let likeCount = 0;
      let secondLikeCount = likeCount;
      try {
        const data = await getDocs(likeCountCollectionRef);
        const filteredData = data.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        filteredData.map((likes) => {
          likeCount = likes.likeCount;
          secondLikeCount = likeCount + 1;
          setLikeId(likes.id);
        });
        setLikeCount(likeCount);
        setLikeCountTwo(secondLikeCount);
        setNewLike(secondLikeCount);
      } catch (err) {
        console.error(err);
      }
    };
    getLikes();
  }, []);

  const likeCountHandle = async () => {
    const likeDoc = doc(db, "likes", likeId);
    await updateDoc(likeDoc, { likeCount: newLike });
  };

  return (
    <div className="like-container">
      <div className="like-inner">
        <div className="like-con">
          <h1>{aboutSec.dec3}</h1>
          <div>
            <div className="img-like">
              <img src={imageAbout} alt="" />
            </div>
            <br />
            <div>
              <div className="like-button" onClick={likeCountHandle}>
                <input className="on" id="heart" type="checkbox" />
                <label className="like" htmlFor="heart">
                  <svg
                    className="like-icon"
                    fillRule="nonzero"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z"></path>
                  </svg>
                  <span className="like-text">Likes</span>
                </label>
                <span className="like-count one">{likeCount}</span>
                <span className="like-count two">{likeCountTwo}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
